import { formatApiDateRangeDisplay } from '#/utils/date';

/**
 * UI range DatePicker ↔ listQuery.filters（API：`adjustment_date_from`／`adjustment_date_to`）。
 */
export function readAdjustmentDateRangeFilter(filters = {}) {
  const from = filters.adjustmentDateFrom;
  const to = filters.adjustmentDateTo;

  if (!from && !to) {
    return undefined;
  }

  return {
    from: from ?? '',
    to: to ?? from ?? '',
  };
}

export function applyAdjustmentDateRangeToFilters(filters = {}, range) {
  const next = { ...filters };

  if (!range?.from && !range?.to) {
    delete next.adjustmentDateFrom;
    delete next.adjustmentDateTo;
    return next;
  }

  const from = range.from;
  const to = range.to || range.from;

  next.adjustmentDateFrom = from || undefined;
  next.adjustmentDateTo = to || undefined;

  return next;
}

export function resolveAdjustmentDateFilterChipDisplay(_values, ctx = {}) {
  const display = formatApiDateRangeDisplay({
    from: ctx.filters?.adjustmentDateFrom,
    to: ctx.filters?.adjustmentDateTo,
  });

  return display ? [display] : [];
}
